import type { BookingPreferenceType, EditPreferencesFormValues } from '../../../domain/types'
import { CheckboxField } from '@sunwebgroup/uds-ui/fields/checkbox-field'
import { TextField } from '@sunwebgroup/uds-ui/fields/text-field'
import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from '@/intl'
import { isCustomerInputMissing } from '../../../domain/editPreferencesRules'
import styles from './EditPreferencesForm.module.css'

interface PreferenceFieldProps {
  index: number
  label: string
  type: BookingPreferenceType
  isHidden: boolean
}

export function PreferenceField({ index, label, type, isHidden }: PreferenceFieldProps) {
  const { control } = useFormContext<EditPreferencesFormValues>()

  return (
    <Controller
      control={control}
      name={`preferences.${index}.isSelected`}
      render={({ field }) => (
        <div className={styles.preference} hidden={isHidden}>
          <CheckboxField
            variant="outlined"
            label={label}
            checked={field.value}
            onCheckedChange={checked => field.onChange(checked === true)}
          />
          {type === 'CustomerInput' && field.value && <CustomerInputField index={index} label={label} />}
        </div>
      )}
    />
  )
}

function CustomerInputField({ index, label }: { index: number, label: string }) {
  const { formatMessage } = useIntl()
  const { control } = useFormContext<EditPreferencesFormValues>()

  return (
    <Controller
      control={control}
      name={`preferences.${index}.customerInput`}
      rules={{ validate: (_, formValues) => !isCustomerInputMissing(formValues.preferences[index]) }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          ariaLabel={label}
          status={fieldState.invalid ? 'error' : 'default'}
          feedbackText={fieldState.invalid
            ? formatMessage({ id: 'booking_details_preferences_edit_required_error' })
            : undefined}
        />
      )}
    />
  )
}
